import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from "@angular/core";

import { LoggerService } from "@bfx/logger";
import { DomHandler } from "@bfx/primeng/dom";
import { Subscription } from "rxjs";
import { BfxMultiSelectorService } from "./bfx-multi-selector.service";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";
import { MULTI_SELECTOR_LIMIT } from "./bfx-multi-selector.constants";

@Component({
  selector: "bfx-multi-selector",
  templateUrl: "./html/bfx-multi-selector.html",
  standalone: false,
})
export class BfxMultiSelectorComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  // TODO Generic use outside of FilterManager & Find requires additional styling

  @Input()
  public text: string = "";

  @Input()
  public panelStyleClass: string = "bfx-multi-selector-dropdown";

  @Input("alternativeOptionsLabel")
  public alternativeOptionsLabel: string = null;

  public alternativeActive: boolean = false;

  @Input("optionsLabel")
  public optionsLabel = null;

  @Input("optionSingleSelection")
  public optionSingleSelection: boolean = false;

  @Input("unsorted")
  public unsorted: boolean = false;

  @Input("showOptionsUpdatesText")
  public showOptionsUpdatesText = false;

  public _altOptions: Array<any> = [];
  public _options: Array<any> = [];

  public _optionsValueMap = new Map<string, object>();
  public _altOptionsValueMap = new Map<string, object>();

  @Input("alternativeInclusive")
  public _alternativeInclusive = false;

  @Input("optionType")
  public _optionType: string = null;

  @Input("alternativeType")
  public _alternativeType: string = null;

  @Output("selectedOptions")
  public selectedOptionsEmitter: EventEmitter<any> = new EventEmitter();

  @Output("altSelectedOptions")
  public altSelectedOptionsEmitter: EventEmitter<any> = new EventEmitter();

  @Output() onOpen: EventEmitter<any> = new EventEmitter();

  @Output() onClose: EventEmitter<any> = new EventEmitter();

  @Input("selectedOptions")
  public selectedOptions: Array<any> = [];

  @Input("altSelectedOptions")
  public altSelectedOptions: Array<any> = [];

  @Input() disableInput: boolean;

  @Input("proxyTab")
  public tabForward: (event) => void = null;

  @Input("optionsLookupFn")
  private optionsLookupFn = null;

  @ViewChild("dropdown", { read: ElementRef })
  private dropdown: ElementRef;

  @ViewChild("wrapper", { read: ElementRef })
  private wrapper: ElementRef;

  @ViewChild("listWrapper", { read: ElementRef })
  private listWrapper: ElementRef;

  @ViewChildren("optionElem", { read: ElementRef })
  private optionElems: QueryList<ElementRef>;

  @ViewChild("entry", { read: ElementRef })
  private entry: ElementRef;

  @ViewChild("selectorButton", { read: ElementRef })
  private selectorButton: ElementRef;

  @ViewChild("altSelectorButton", { read: ElementRef })
  private altSelectorButton: ElementRef;

  public autocloseListener: any;
  public documentKeydownListener: any;

  public shownOptions: Array<any> = [];
  public _showOptions: boolean = false;
  public selectedOptionText: string = "";
  public elementRef;
  protected rect: any;
  private tabIndex: number = 1;
  private subscription: Subscription;
  private _hasFocus: boolean = false;

  public highlightElem: any = null;
  public highlightOption: any = null;
  public highlightIndex: number = -1;
  public lastActiveIndex: number = -1;
  public targetDocument;

  private highlightMouseEnterPos = {
    x: -1,
    y: -1,
  };

  private highlightMouseLeavePos = {
    x: -1,
    y: -1,
  };
  private _cdDestroyGuard: boolean = false;
  // private baseZIndex: number = 0;

  //
  // this.base
  constructor(
    myElement: ElementRef,
    private selectorService: BfxMultiSelectorService,
    public domHandler: DomHandler,
    public renderer: Renderer2,
    public cd: ChangeDetectorRef,
  ) {
    this.elementRef = myElement;
  }
  ngOnInit() {
    this.cleanSelectedOptions();
  }

  ngAfterViewInit() {
    this.updateSelectedOptionText();

    this.targetDocument = document;

    if (NativeDesktopSupport.isNativeDesktopContainer()) {
      let wnd = NativeDesktopSupport.getWindow(this.elementRef.nativeElement);
      wnd.getNativeWindow().document.body.appendChild(this.dropdown.nativeElement);
    } else {
      document.body.appendChild(this.dropdown.nativeElement);
    }

    this.subscription = this.selectorService.keyDownObservable$.subscribe((ev) => {
      if (ev) this.keyEventFromParent(ev);
    });

    this.onOpen.subscribe(() => {
      setTimeout(() => {
        this.showDropdown();
      }, 4);
    });

    this.onClose.subscribe(() => {
      this.hideDropdown();
    });

    if (this.showOptions) {
      setTimeout(() => {
        this.showDropdown();
      }, 4);
    } else {
      this.hideDropdown();
    }
  }

  ngOnDestroy() {
    this._cdDestroyGuard = true;
    this.subscription.unsubscribe();
    this.unbindAutcloseHandler();
  }

  /**
   * Track changes to selectedOptions when options are not changed - this requires the options list
   * to be updated to ensure the 'checked's are accurate
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    // Where we have selected options being applied without changes to options e.g. in findOrders
    // we need to recalc values - note: this will not work for current alternative values model
    if (!this.alternativeOptions || (this.alternativeOptions.length == 0 && !this.showOptions)) {
      if (
        (changes["selectedOptions"] !== undefined || changes["altSelectedOptions"] !== undefined) &&
        changes["options"] === undefined
      ) {
        if (this.alternativeActive) {
          this._altOptions.forEach((a) => (a["checked"] = false));
          this.updateShownOptions(this._altOptions, this._altOptionsValueMap);
        } else {
          this._options.forEach((a) => (a["checked"] = false));
          this.updateShownOptions(this._options, this._optionsValueMap);
        }
      }
    }
  }

  public textChanged(newText: string) {
    this.text = newText;
    let options = this.alternativeActive ? this.alternativeOptions : this.options;

    if (this.optionsLookupFn) {
      let filteredSet = new Set<string>();
      let include: boolean;
      let filtered = options.filter((o) => {
        include =
          o.checked ||
          (this.text &&
            this.text.length > 0 &&
            o.label.toLowerCase().indexOf(this.text.toLowerCase()) >= 0);

        if (include) filteredSet.add(this.getStringValue(o));

        return include;
      });
      let requestSize = MULTI_SELECTOR_LIMIT - filtered.length;

      let promise;

      if (requestSize > 0) {
        promise = this.optionsLookupFn({
          prefix: this.text,
          skip: 0,
          limit: requestSize,
        });
      } else {
        promise = new Promise<any>((res) => res([]));
      }

      promise.then((additionalOptions: { label: string; value: string }[]) => {
        additionalOptions.forEach((a) => {
          const strValue = this.getStringValue(a);
          if (!filteredSet.has(strValue)) {
            // clone a, to use safely as we mutate in-place
            filtered = [...filtered, Object.assign({}, a)];
            filteredSet.add(strValue);
          }
        });
        this.shownOptions = this.sortOptions(filtered, true);

        if (!this._cdDestroyGuard) this.cd.detectChanges();

        setTimeout(() => {
          if (this.showOptions) this.showDropdown();
        }, 4);
      });
    } else {
      let filtered = options.filter((o) => {
        return o.checked || o.label.toLowerCase().indexOf(this.text.toLowerCase()) >= 0;
      });
      this.shownOptions = this.sortOptions(filtered, true);
      if (!this._cdDestroyGuard) this.cd.detectChanges();

      setTimeout(() => {
        if (this.showOptions) this.showDropdown();
      }, 4);
    }
  }

  /**
   * convert the list item to a single string for use in lookups and comparisons. It will return in priority order:
   * 1. item._findValue if defined
   * 2. item.value (if string)
   * 3. item.label (if value is object)
   * 4. item.value.toString()
   * @param listItem
   * @returns
   */
  private getStringValue(listItem: { label: string; value: any; _findValue?: string }): string {
    if (!listItem) {
      return "";
    }

    // Stored values can come from _findValue values so prioritise these
    if (typeof listItem._findValue === "string") {
      return listItem._findValue;
    }
    if (typeof listItem.value === "string") {
      return listItem.value;
    }
    if (listItem.value !== null && typeof listItem.value === "object") {
      return listItem.label;
    }
    return listItem.value?.toString() ?? "";
  }

  private sortOptions(option: Array<any>, modifyHighlight: boolean = false): Array<any> {
    let o = option.map((a, i) => {
      return {
        i: i,
        checked: a.checked,
        label: a.label.toLowerCase(),
      };
    });

    if (!this.unsorted) {
      o.sort(function (a, b) {
        if ((a.checked === true) === (b.checked === true)) {
          let x = a.label,
            y = b.label;
          return x < y ? -1 : x > y ? 1 : 0;
        }
        return a.checked ? -1 : 1;
      });
    } else {
      o.sort(function (a, b) {
        return a.checked ? -1 : 1;
      });
    }

    this.lastActiveIndex = -1;

    o = o.map((a, i) => {
      if (a.checked) {
        this.lastActiveIndex = i;
      }

      return option[a.i];
    });

    if (modifyHighlight && o.length > 0 && o.length > this.lastActiveIndex + 1) {
      this.highlightElem = null;
      this.highlightOption = o[this.lastActiveIndex + 1];
      this.highlightIndex = this.lastActiveIndex + 1;
    } else if (o.length == 0) {
      this.highlightElem = null;
      this.highlightIndex = -1;
      this.highlightOption = null;
    }

    return o;
  }

  public optionToggle(option: any, optionElem: any = null, index: number) {
    if (this.optionSingleSelection) {
      this.clearAll();
    }
    option["checked"] = !option["checked"];

    const strValue = this.getStringValue(option);
    if (
      option["checked"] === true &&
      this.optionsLookupFn &&
      !this._optionsValueMap.has(strValue)
    ) {
      this._options.push(option);
      this._optionsValueMap.set(strValue, option);
    } else if (
      option["checked"] === true &&
      this.optionsLookupFn &&
      this._optionsValueMap.has(strValue)
    ) {
      let i = this._options.findIndex((o) => {
        return option.value === o.value;
      });

      if (i >= 0) this._options[i]["checked"] = true;
    } else if (
      option["checked"] !== true &&
      this.optionsLookupFn &&
      this._optionsValueMap.has(strValue)
    ) {
      let i = this._options.findIndex((o) => {
        return option.value === o.value;
      });
      this._options.splice(i, 1);
      this._optionsValueMap.delete(strValue);
    }

    this.highlightOption = option;
    this.highlightElem = optionElem;
    this.highlightIndex = index;

    let selectedFilterOptions = this.alternativeActive ? this.alternativeOptions : this.options;
    let altSelectedFilterOptions = this.alternativeActive ? this.options : this.alternativeOptions;
    this.selectedOptions = selectedFilterOptions.filter((a) => a["checked"]);
    this.altSelectedOptions = altSelectedFilterOptions.filter((a) => a["checked"]);
    this.updateSelectedOptionText();

    if (this.optionSingleSelection) {
      this.showOptions = false;
    }

    this.selectedOptionsEmitter.emit({
      selectedOptions: this.selectedOptions,
      alternativeActive: this.alternativeActive,
    });
    this.altSelectedOptionsEmitter.emit({
      altSelectedOptions: this.altSelectedOptions,
      alternativeActive: this.alternativeActive,
    });
  }

  public updateSelectedOptionText(): void {
    this.selectedOptionText = "";
    if (this._alternativeInclusive) {
      if (Array.isArray(this.selectedOptions) && this.selectedOptions.length !== 0) {
        let labelPrefix: string = this.alternativeActive
          ? `${this.alternativeOptionsLabel}: `
          : `${this.optionsLabel}: `;
        this.formatSelectedOptionText(labelPrefix, this.selectedOptions);
      }

      if (Array.isArray(this.altSelectedOptions) && this.altSelectedOptions.length !== 0) {
        let labelPrefix: string = this.alternativeActive
          ? `${this.optionsLabel}: `
          : `${this.alternativeOptionsLabel}: `;
        this.formatSelectedOptionText(labelPrefix, this.altSelectedOptions);
      }
    } else if (Array.isArray(this.selectedOptions)) {
      this.selectedOptions.forEach((a) => (this.selectedOptionText += a.label + ", "));
      this.selectedOptionText = this.selectedOptionText.substring(
        0,
        this.selectedOptionText.length - 2,
      );
    }
  }

  private formatSelectedOptionText(labelPrefix: string, array: any[]) {
    this.selectedOptionText +=
      labelPrefix +
      array
        .map((el) => el.label)
        .join(", ")
        .concat(". ");
  }

  public get options(): Array<any> {
    return this._options;
  }

  @Input("options")
  public set options(masterOptions: Array<any>) {
    // Note that this logic is dependent on the selectedOptions being set before options - may be better to move to
    // an ngOnChanges() flow instead
    if (masterOptions) {
      const options = this.cloneOptions(masterOptions);
      if (!this._cdDestroyGuard) this.cd.detach();

      this._options = options;

      this.updateValueMap(this._options, this._optionsValueMap);

      if (!this.alternativeActive) this.updateShownOptions(this._options, this._optionsValueMap);

      if (!this._cdDestroyGuard) this.cd.reattach();
    }
  }

  public get alternativeOptions(): Array<any> {
    return this._altOptions;
  }

  @Input("alternativeOptions")
  public set alternativeOptions(masterOptions: Array<any>) {
    if (masterOptions) {
      const options = this.cloneOptions(masterOptions);
      if (!this._cdDestroyGuard) this.cd.detach();

      this._altOptions = options;

      this._altOptionsValueMap.clear();

      this.updateValueMap(this._altOptions, this._altOptionsValueMap, true);

      if (this.alternativeActive)
        this.updateShownOptions(this._altOptions, this._altOptionsValueMap);

      if (!this._cdDestroyGuard) this.cd.reattach();
    }
  }

  /**
   * Make a local copy of the option list and members as these may be shared between multiple components
   * e.g. in Filters, an OR filter can have 2 different Client ID components with same input list of options
   * @param masterOptions
   * @returns
   */
  private cloneOptions(masterOptions: any[]): any[] {
    if (masterOptions) {
      return masterOptions.map((option) => {
        return Object.create(option);
      });
    }
    return [];
  }

  private updateValueMap(options, valueMap, altOptions = false) {
    valueMap.clear();
    this.cleanSelectedOptions();
    let selectedOptions: any[] = altOptions ? this.altSelectedOptions : this.selectedOptions;
    let checked = false;

    options.forEach((a) => {
      if (a && a.value != null) {
        valueMap.set(this.getStringValue(a), a);
        if (selectedOptions != null && selectedOptions.length > 0) {
          checked = selectedOptions.some((elem) => elem.value === a.value);
        }
        a["checked"] = checked;
      }
    });
    return valueMap;
  }

  public updateShownOptions(options, valueMap): void {
    let filteredOptions = options.filter(
      (o) => this.text.length == 0 || o.label.toLowerCase().indexOf(this.text.toLowerCase()) >= 0,
    );

    this.selectedOptions =
      this.selectedOptions != null
        ? this.selectedOptions
            .map((a) => {
              if (a && a.value != null) {
                let option = valueMap.get(this.getStringValue(a));
                if (!option) return null;
                option["checked"] = true;
                return option;
              } else {
                return null;
              }
            })
            .filter((a) => a !== null)
        : [];

    this.highlightElem = null;
    this.highlightIndex = -1;
    this.highlightOption = null;
    this.shownOptions = this.sortOptions(filteredOptions);

    // When the dropdown is closed we call textChanged which resets the length to
    // 50  so we must use that constraint here too to ensure consistency
    if (this.optionsLookupFn && this.shownOptions.length > MULTI_SELECTOR_LIMIT) {
      this.shownOptions.length = MULTI_SELECTOR_LIMIT;
    }

    if (this.showOptionsUpdatesText) {
      this.updateSelectedOptionText();
    }

    if (this.showOptions) {
      if (!this._cdDestroyGuard) this.cd.detectChanges();

      setTimeout(() => {
        this.showDropdown();
      }, 4);
    }
  }

  @Input("hasFocus")
  public set hasFocus(hasFocus: boolean) {
    this._hasFocus = hasFocus;
  }

  public get showOptions(): boolean {
    return this._showOptions;
  }

  @Input()
  public set showOptions(showOptions: boolean) {
    this._showOptions = showOptions;
    this.shownOptions = this.sortOptions(this.shownOptions, true);

    if (!this._cdDestroyGuard) this.cd.detectChanges();

    setTimeout(() => {
      if (showOptions) {
        this.bindAutocloseHandler();

        this.onOpen.emit();
      } else {
        this.unbindAutcloseHandler();

        this.onClose.emit();
      }
    }, 4);
  }

  public hideDropdown(): void {
    if (this.dropdown && this.dropdown.nativeElement) {
      this.dropdown.nativeElement.style.display = this.showOptions ? "block" : "none";
    }
  }

  public showDropdown(): void {
    let optionContainer = this.listWrapper.nativeElement
      ? this.listWrapper.nativeElement.querySelector("ul")
      : null;
    let optionElements = Array.from(optionContainer.children);
    let nextItemIndex = this.lastActiveIndex + 1;

    if (optionElements.length > nextItemIndex) {
      this.highlightElem = optionElements[nextItemIndex];
      this.highlightIndex = nextItemIndex;
      this.highlightOption = this.shownOptions[nextItemIndex];
    }

    if (this.wrapper.nativeElement.ownerDocument != this.dropdown.nativeElement.ownerDocument) {
      this.wrapper.nativeElement.ownerDocument.body.appendChild(this.dropdown.nativeElement);
      this.unbindAutcloseHandler();
      this.targetDocument = this.wrapper.nativeElement.ownerDocument;
      this.bindAutocloseHandler();
    }

    if (
      NativeDesktopSupport.isNativeDesktopContainer() &&
      this.targetDocument != null &&
      this.targetDocument != this.wrapper.nativeElement.ownerDocument
    ) {
      this.unbindAutcloseHandler();
      this.targetDocument = this.wrapper.nativeElement.ownerDocument;
      this.bindAutocloseHandler();
    }

    if (this.entry && this.entry.nativeElement) {
      this.entry.nativeElement.focus();

      if (this.dropdown && this.dropdown.nativeElement) {
        this.dropdown.nativeElement.style.display = this.showOptions ? "block" : "none";

        if (this.entry.nativeElement.offsetTop == 0 && this.entry.nativeElement.offsetLeft == 0) {
          logger.out.info(
            `${this.constructor.name}.showDropdown failed to acquire valid absolutePosition`,
          );
          this.showOptions = false;
          this.hideDropdown();
        } else {
          DomHandler.absolutePosition(this.dropdown.nativeElement, this.entry.nativeElement);
        }
      }
    }

    if (
      this.listWrapper.nativeElement &&
      this.optionElems.first &&
      this.optionElems.first.nativeElement
    ) {
      this.scrollInView(this.listWrapper.nativeElement, this.optionElems.first.nativeElement);
    }
  }

  public switchToOptions(): void {
    if (this.alternativeActive) {
      this.alternativeActive = false;

      [this.selectedOptions, this.altSelectedOptions] = [
        this.altSelectedOptions,
        this.selectedOptions,
      ];

      this.updateShownOptions(this._options, this._optionsValueMap);
    }
  }

  public switchToAltOptions(): void {
    if (!this.alternativeActive) {
      this.alternativeActive = true;

      [this.selectedOptions, this.altSelectedOptions] = [
        this.altSelectedOptions,
        this.selectedOptions,
      ];

      this.updateShownOptions(this._altOptions, this._altOptionsValueMap);
    }
  }

  public clearAll(): void {
    this.alternativeOptions.forEach((a) => (a["checked"] = false));
    this.options.forEach((a) => (a["checked"] = false));
    this.selectedOptions = [];
    this.altSelectedOptions = [];
    this.selectedOptionText = "";
    this.lastActiveIndex = -1;
    this.textChanged("");
    this.selectedOptionsEmitter.emit(this.selectedOptions);
    this.altSelectedOptionsEmitter.emit(this.altSelectedOptions);
  }

  public showOptionsOnClick(): void {
    if (this.disableInput) return;
    if (!this.showOptions) this.showOptions = true;
  }

  public keyEventFromParent(event): void {
    if (event.keyCode == 32 && this._hasFocus === true && this._showOptions) {
      this.showOptionsOnClick();
    }
  }

  public onKeydown(event): boolean {
    // logger.out.warn(`${this.constructor.name}.onKeyDown(%O): [ENTER] %O %O %O `, event, this.highlightOption, this.highlightIndex,  this.highlightElem);
    let passthrough = false;

    if (this.showOptions) {
      let optionContainer = this.listWrapper.nativeElement
        ? this.listWrapper.nativeElement.querySelector("ul")
        : null;
      let optionElements = Array.from(optionContainer.children);

      switch (event.which) {
        //down
        case 40:
          if (this.highlightIndex != -1) {
            let nextItemIndex = this.highlightIndex + 1;
            if (nextItemIndex != this.shownOptions.length) {
              this.highlightElem = optionElements[nextItemIndex];
              this.highlightIndex = nextItemIndex;
              this.highlightOption = this.shownOptions[nextItemIndex];
            }
          } else {
            this.highlightElem = optionElements[0];
            this.highlightIndex = 0;
            this.highlightOption = this.shownOptions[0];
          }
          break;
        //up
        case 38:
          if (this.highlightIndex > 0) {
            let prevItemIndex = this.highlightIndex - 1;
            this.highlightElem = optionElements[prevItemIndex];
            this.highlightIndex = prevItemIndex;
            this.highlightOption = this.shownOptions[prevItemIndex];
          }
          break;
        //enter
        case 13:
          if (
            typeof this.text === "string" &&
            this.text.length > 0 &&
            this.highlightOption &&
            this.highlightOption.checked !== true
          ) {
            if (
              (typeof this.highlightOption.value === "string" &&
                this.highlightOption.value.toLowerCase().indexOf(this.text.toLowerCase()) != -1) ||
              this.highlightOption.label.toLowerCase().indexOf(this.text.toLowerCase()) != -1
            ) {
              this.optionToggle(
                this.highlightOption,
                optionElements[this.highlightIndex],
                this.highlightIndex,
              );
            }
          } else if (this.highlightOption) {
            this.optionToggle(
              this.highlightOption,
              optionElements[this.highlightIndex],
              this.highlightIndex,
            );
          } else {
            passthrough = true;
          }
          this.textChanged("");
          break;
        //escape
        case 27:
          if (this.showOptions) {
            this.highlightElem = null;
            this.highlightIndex = -1;

            this.showOptions = false;

            this.textChanged("");
          }
          passthrough = true;

          break;
        //tab
        case 9:
          if (
            typeof this.text === "string" &&
            this.text.length > 0 &&
            this.highlightIndex > this.lastActiveIndex &&
            this.highlightOption &&
            this.highlightOption.checked !== true
          ) {
            if (
              (typeof this.highlightOption.value === "string" &&
                this.highlightOption.value.toLowerCase().indexOf(this.text.toLowerCase()) != -1) ||
              this.highlightOption.label.toLowerCase().indexOf(this.text.toLowerCase()) != -1
            ) {
              this.optionToggle(
                this.highlightOption,
                optionElements[this.highlightIndex],
                this.highlightIndex,
              );
            }
          }

          if (this.showOptions) this.showOptions = false;

          this.textChanged("");

          this.highlightElem = null;
          this.highlightIndex = -1;
          this.highlightOption = null;

          if (this.tabForward) {
            if (
              event.target === document ||
              event.target === document.body ||
              event.target === this.targetDocument ||
              event.target === this.targetDocument.body
            ) {
              passthrough = false;
            }

            this.tabForward(event);
          } else {
            passthrough = true;
          }
          break;
        default:
          passthrough = true;

          break;
      }
      // logger.out.warn(`${this.constructor.name}.onKeyDown(%O): [EXIT] %O %O %O `, event, this.highlightOption, this.highlightIndex,  this.highlightElem);

      setTimeout(() => {
        if (this.highlightElem) {
          this.scrollInView(this.listWrapper.nativeElement, this.highlightElem);
        }
      }, 4);
    }

    if (!passthrough) {
      event.preventDefault();

      return passthrough;
    }
  }

  // update highlight for automation
  // avoids tab pulling in an extra selected item accidentally FXBFXOM-5203
  public onClick($event, highlightOption, highlightElem, highlightIndex) {
    this.onMouseMoveHighlight($event, highlightOption, highlightElem, highlightIndex);
    this.optionToggle(highlightOption, highlightElem, highlightIndex);
  }

  public onMouseMoveHighlight($event, highlightOption, highlightElem, highlightIndex) {
    // logger.out.warn(`${this.constructor.name}.onMouseMoveHighlight(%O): [ENTER] %O %O %O `, event, this.highlightOption, this.highlightIndex,  this.highlightElem);
    let x = $event.screenX;
    let y = $event.screenY;
    let deadzone = 5;

    if (
      Math.abs(this.highlightMouseEnterPos.x - x) > deadzone ||
      Math.abs(this.highlightMouseEnterPos.y - y) > deadzone
    ) {
      this.highlightMouseEnterPos.x = x;
      this.highlightMouseEnterPos.y = y;
    } else {
      // view has changed (keyboard) but mouse has not moved more than deadzone
      return;
    }

    if (this.highlightOption != highlightOption) {
      this.highlightOption = highlightOption;
      this.highlightElem = highlightElem;
      this.highlightIndex = highlightIndex;
    }

    // logger.out.warn(`${this.constructor.name}.onMouseMoveHighlight(%O): [EXIT] %O %O %O `, event, this.highlightOption, this.highlightIndex,  this.highlightElem);
  }

  private scrollInView(container, item) {
    DomHandler.scrollInView(container, item);
  }

  private getOuterHeight(el, margin?) {
    let height = el.offsetHeight;

    if (margin) {
      let style = getComputedStyle(el);
      height += parseFloat(style.marginTop) + parseFloat(style.marginBottom);
    }

    return height;
  }

  private findSingle(element: any, selector: string): any {
    return element.querySelector(selector);
  }

  public onInputFocus(event: any): void {
    if (!this.showOptions) this.showOptions = true;

    event.target.select();
  }

  private cleanSelectedOptions(): void {
    this.selectedOptions =
      this.selectedOptions != null && this.selectedOptions.every((elem) => elem != null)
        ? this.selectedOptions
        : [];
  }

  private bindAutocloseHandler(): void {
    if (!this.autocloseListener) {
      this.autocloseListener = this.renderer.listen(this.targetDocument, "mousedown", (event) => {
        if (this.showOptions) {
          let element: any = event.target;
          let depth = 0;

          if (
            (this.selectorButton && event.target == this.selectorButton.nativeElement) ||
            (this.altSelectorButton && event.target == this.altSelectorButton.nativeElement)
          ) {
            return;
          }

          if (
            (this.selectorButton && this.selectorButton.nativeElement.contains(event.target)) ||
            (this.altSelectorButton && this.altSelectorButton.nativeElement.contains(event.target))
          ) {
            return;
          }

          while (
            element &&
            element.classList &&
            !(
              element.classList.contains("bfx-multi-selector-dropdown") ||
              element.classList.contains("bfx-find-filter-selector--input")
            ) &&
            depth < 20
          ) {
            element = element.parentElement;
            depth++;
          }

          if (element == null || depth >= 20) {
            if (this.showOptions) {
              this.showOptions = false;
              this.highlightElem = null;
              this.highlightIndex = -1;
              this.textChanged("");

              if (this.entry && this.entry.nativeElement) this.entry.nativeElement.blur();
            }
          }
        }
      });
    }

    if (!this.documentKeydownListener) {
      this.documentKeydownListener = this.renderer.listen(
        this.targetDocument,
        "keydown",
        (event) => {
          // logger.out.info(`${this.constructor.name}.documentKeyDownListener %O target: %O, which: %O`,
          //     event, event.target, event.which);

          this.onKeydown(event);
        },
      );
    }
  }

  private unbindAutcloseHandler(): void {
    if (this.autocloseListener) {
      this.autocloseListener();
      this.autocloseListener = null;
    }

    if (this.documentKeydownListener) {
      this.documentKeydownListener();
      this.documentKeydownListener = null;
    }
  }
}
